// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"2f64c5e8","525":"b6afb15c","612":"3957e93f","805":"9301695d"}[chunkId] + ".chunk.js";
};